import React, { useEffect, useState } from "react";
import TableSkeleton from "../../../../../common/TableSkeleton";
import DashboardButton from "../DashboardButton";

const TopSelling = () => {
    const [topSeller, setTopSeller] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const url = `${EASYCOMMERCE.rest_base}/dashboard/topsellers`;

        fetch(url,{
            headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": EASYCOMMERCE.nonce,
            }
        })
            .then((res) => res.json())
            .then((data) => {
                setIsLoading(false);

                if (data.success) {
                    setTopSeller(data.data.sellers);
                }
            });
    }, []);

    const handleProductClick = (productId) => {
        // Navigate to orders page with product filter using the new URL pattern
        window.location.hash = `#/orders/product/${productId}`;
    };

    return (
        <>
            {isLoading ? (
                <TableSkeleton numberOfRows={5} SkeletonHeight={35} />
            ) : topSeller.length === 0 ? (
                <div className=" text-sm text-ec-body px-[30px] pb-[30px]">
                    No top selling products found.
                </div>
            ) : (
                <>  
                    <div className="px-[30px]">
                        <table class="table-auto w-full">
                            <thead>
                                <tr className="bg-ec-table-bg">
                                    <th className="text-xs font-inter text-left font-medium p-3 capitalize rounded-tl-md rounded-bl-md text-ec-body rtl:text-right">
                                        Name
                                    </th>
                                    <th className="text-xs font-inter text-center font-medium p-3 capitalize text-ec-body rounded-tr-md rounded-br-md rtl:text-right">
                                        Sales
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {topSeller.map(
                                    (item, index) =>
                                        index < 5 && (
                                            <>
                                                <tr
                                                    className={`${
                                                        index < 4
                                                            ? "border-b border-[#F8F8F8]"
                                                            : ""
                                                    } h-[70px]`}
                                                    key={index}
                                                >
                                                    <td className="px-3">
                                                        <button
                                                            onClick={() => handleProductClick(item.id)}
                                                            title={item.title.length > 35 ? item.title : null}
                                                            className="py-3 font-inter text-sm text-ec-body hover:text-ec-primary text-left"
                                                        >
                                                            {item.title.length > 35 ? item.title.slice(0, 35) + "..." : item.title}
                                                        </button>
                                                    </td>
                                                    <td className="px-3 font-inter text-center">
                                                        <span
                                                            className="text-ec-body"
                                                        >
                                                            {item.sales}
                                                        </span>
                                                    </td>
                                                </tr>
                                            </>
                                        )
                                )}
                            </tbody>
                        </table>
                    </div>
                    
                    <div className="px-8 pb-8">
                        <DashboardButton url={`admin.php?page=easycommerce#/reports`} />
                    </div> 
                </>
            )}
        </>
    );
};

export default TopSelling;
